import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
  import type { OptionalUpgrade } from "@/types/OptionalUpgradeInterface";
  import ArrowUpLanding from "@/assets/icons/arrow-up-landing.svg";
  import { formatPrice as formatPriceHelper } from "@/helpers/transformation/price";

  const PROMOTIONS_SECTION_TITLE = "PROMOTIONS / OPTIONAL UPGRADES";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorSummaryItemWithImage',
  props: {
    title: {},
    value: {},
    price: {},
    imageUrl: {},
    isMobile: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const isUpgradeSection = computed(
    () =>
      props.title === PROMOTIONS_SECTION_TITLE &&
      Array.isArray(props.value) &&
      props.value !== null
  );

  const isFloorplan = computed(() => props.title === "FLOOR PLAN");

  const formatPrice = (price: number | null): string => {
    if (price === null || price === undefined) return "";

    return price === 0 ? "Included" : formatPriceHelper(price, true);
  };

  const isExpanded = ref(false);

  const toggleExpand = () => {
    isExpanded.value = !isExpanded.value;
  };

const __returned__ = { PROMOTIONS_SECTION_TITLE, props, isUpgradeSection, isFloorplan, formatPrice, isExpanded, toggleExpand, computed, ref, get ArrowUpLanding() { return ArrowUpLanding }, get formatPriceHelper() { return formatPriceHelper } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})